import { render, staticRenderFns } from "./mtcLangPopover.vue?vue&type=template&id=7cb76f1e&"
import script from "./mtcLangPopover.vue?vue&type=script&lang=js&"
export * from "./mtcLangPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports